import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";
import NewsletterForm from "@/components/NewsletterForm";
import PapersList from "@/components/PapersList";
import CareersList from "@/components/CareersList";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SPECIAL = {
  "contact-us": ContactForm,
  newsletter: NewsletterForm,
  "research-papers": (props) => <PapersList {...props} type="research" />,
  careers: CareersList,
};

export default function CmsPage({ slug: propSlug }) {
  const params = useParams();
  const slug = propSlug || params.slug;
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let m = true;
    setLoading(true);
    axios.get(`${API}/pages/${slug}`)
      .then((r) => m && setPage(r.data))
      .catch(() => m && setPage(null))
      .finally(() => m && setLoading(false));
    return () => { m = false; };
  }, [slug]);

  const SpecialComponent = SPECIAL[slug];

  return (
    <div className="min-h-screen bg-stone-950 text-white flex flex-col" data-testid={`cms-page-${slug}`}>
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-20 w-full">
        {loading && <p className="text-stone-500 text-sm">Loading…</p>}
        {!loading && !page && (
          <p className="text-stone-500 text-sm">Page not found.</p>
        )}
        {!loading && page && (
          <>
            <header className="mb-10 pb-8 border-b border-stone-800">
              <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                {page.title}
              </h1>
              {page.subtitle && (
                <p className="text-sm sm:text-base text-emerald-400 mt-3 font-body">{page.subtitle}</p>
              )}
            </header>

            <article className="prose prose-invert prose-emerald max-w-none prose-headings:font-heading prose-p:text-stone-300 prose-p:leading-relaxed prose-li:text-stone-300 prose-a:text-emerald-400 prose-strong:text-white"
              dangerouslySetInnerHTML={{ __html: page.body_html || "" }} />

            {SpecialComponent && (
              <div className="mt-12 pt-8 border-t border-stone-800">
                <SpecialComponent page={page} />
              </div>
            )}

            {slug === "contact-us" && (page.contact_email || page.contact_phone || page.contact_address) && (
              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
                {page.contact_email && (
                  <div className="bg-stone-900 rounded-xl border border-stone-800 p-4">
                    <p className="text-[10px] text-stone-500 uppercase tracking-wider mb-1">Email</p>
                    <a href={`mailto:${page.contact_email}`} className="text-emerald-400 hover:text-emerald-300 text-sm break-all">{page.contact_email}</a>
                  </div>
                )}
                {page.contact_phone && (
                  <div className="bg-stone-900 rounded-xl border border-stone-800 p-4">
                    <p className="text-[10px] text-stone-500 uppercase tracking-wider mb-1">Phone</p>
                    <a href={`tel:${page.contact_phone}`} className="text-emerald-400 hover:text-emerald-300 text-sm">{page.contact_phone}</a>
                  </div>
                )}
                {page.contact_address && (
                  <div className="bg-stone-900 rounded-xl border border-stone-800 p-4">
                    <p className="text-[10px] text-stone-500 uppercase tracking-wider mb-1">Address</p>
                    <p className="text-sm text-stone-300 whitespace-pre-line">{page.contact_address}</p>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
